import {
  AxisInputTier1Tier2,
  AxisType,
  CoordinateInputTier3,
  CountParametersTier1Tier2,
  GroupByEnum,
  targetAxis,
} from "./types";

const mapToCorrectXY = (c: {
  x: AxisInputTier1Tier2;
  y: AxisInputTier1Tier2;
}): { x: AxisInputTier1Tier2; y: AxisInputTier1Tier2; isSwitched: boolean } => {
  const { x, y } = c;
  if (COORDS.findIndex((f) => f.x === x.type && f.y === y.type) === -1) {
    return { x: y, y: x, isSwitched: true };
  } else {
    return { x, y, isSwitched: false };
  }
};

export const correctTier12XY = (
  q: CountParametersTier1Tier2
): CountParametersTier1Tier2 => {
  const { x, y } = mapToCorrectXY({ x: q.coordinate.x, y: q.coordinate.y });
  return {
    ...q,
    coordinate: {
      z: q.coordinate.z,
      x,
      y,
    },
  };
};

export const fixTier3XY = (
  cord: CoordinateInputTier3
): CoordinateInputTier3 => {
  const { isSwitched, x, y } = mapToCorrectXY({
    x: cord.x,
    y: cord.y,
  });
  return {
    // @ts-ignore
    x,
    // @ts-ignore
    y,
    z: cord.z,
  };
};

export const correctQueryCordsOrder = (
  q: CountParametersTier1Tier2
): { q: CountParametersTier1Tier2; isSwitched: boolean } => {
  const { isSwitched, x, y } = mapToCorrectXY({
    x: q.coordinate.x,
    y: q.coordinate.y,
  });
  q.targetAxis = isSwitched ? targetAxis.X : targetAxis.Y;
  q.coordinate.x = x;
  q.coordinate.y = y;
  if (
    q.groupBy &&
    isSwitched &&
    (q.groupBy === GroupByEnum.XValue || q.groupBy === GroupByEnum.YValue)
  ) {
    q.groupBy =
      q.groupBy === GroupByEnum.XValue
        ? GroupByEnum.YValue
        : GroupByEnum.XValue;
  }
  return {
    q,
    isSwitched,
  };
};

const COORDS = [
  { x: AxisType.Application, y: AxisType.ContentLabel },
  { x: AxisType.Application, y: AxisType.None },
  { x: AxisType.ContentLabel, y: AxisType.Insight },
  { x: AxisType.EmployeeReceiver, y: AxisType.ContentLabel },
  { x: AxisType.EmployeeReceiver, y: AxisType.EmployeeSender },
  { x: AxisType.EmployeeReceiver, y: AxisType.None },
  { x: AxisType.EmployeeSender, y: AxisType.ContentLabel },
  { x: AxisType.EmployeeSender, y: AxisType.Insight },
  { x: AxisType.EmployeeSender, y: AxisType.None },
  { x: AxisType.Employee, y: AxisType.ContentLabel },
  { x: AxisType.Employee, y: AxisType.EmployeeReceiver },
  { x: AxisType.Employee, y: AxisType.EmployeeSender },
  { x: AxisType.Employee, y: AxisType.ExternalReceiver },
  { x: AxisType.Employee, y: AxisType.Folder },
  { x: AxisType.Employee, y: AxisType.Insight },
  { x: AxisType.Employee, y: AxisType.NonPrivatePersonReceiver },
  { x: AxisType.Employee, y: AxisType.NonPrivatePersonSender },
  { x: AxisType.Employee, y: AxisType.PersonalAddress },
  { x: AxisType.Employee, y: AxisType.None },
  { x: AxisType.ExternalReceiver, y: AxisType.ContentLabel },
  { x: AxisType.ExternalReceiver, y: AxisType.Employee },
  { x: AxisType.ExternalReceiver, y: AxisType.Insight },
  { x: AxisType.ExternalReceiver, y: AxisType.None },
  { x: AxisType.Folder, y: AxisType.ContentLabel },
  { x: AxisType.Folder, y: AxisType.EmployeeReceiver },
  { x: AxisType.Folder, y: AxisType.EmployeeSender },
  { x: AxisType.Folder, y: AxisType.ExternalReceiver },
  { x: AxisType.Folder, y: AxisType.Insight },
  { x: AxisType.Folder, y: AxisType.NonPrivatePersonReceiver },
  { x: AxisType.Folder, y: AxisType.NonPrivatePersonSender },
  { x: AxisType.Folder, y: AxisType.None },
  { x: AxisType.NonPrivatePersonReceiver, y: AxisType.ContentLabel },
  { x: AxisType.NonPrivatePersonReceiver, y: AxisType.EmployeeSender },
  { x: AxisType.NonPrivatePersonReceiver, y: AxisType.None },
  { x: AxisType.NonPrivatePersonSender, y: AxisType.ContentLabel },
  { x: AxisType.NonPrivatePersonSender, y: AxisType.EmployeeSender },
  { x: AxisType.NonPrivatePersonSender, y: AxisType.None },
  { x: AxisType.OrganizationReceiver, y: AxisType.ContentLabel },
  { x: AxisType.OrganizationReceiver, y: AxisType.EmployeeSender },
  { x: AxisType.OrganizationReceiver, y: AxisType.Employee },
  { x: AxisType.OrganizationReceiver, y: AxisType.Folder },
  { x: AxisType.OrganizationReceiver, y: AxisType.Insight },
  { x: AxisType.OrganizationReceiver, y: AxisType.None },
  { x: AxisType.PersonalAddress, y: AxisType.ContentLabel },
  { x: AxisType.PersonalAddress, y: AxisType.EmployeeSender },
  { x: AxisType.PersonalAddress, y: AxisType.Folder },
  { x: AxisType.PersonalAddress, y: AxisType.Insight },
  { x: AxisType.Application, y: AxisType.Insight },
  { x: AxisType.PersonalAddress, y: AxisType.None },
  { x: AxisType.PersonReceiver, y: AxisType.Insight },
  { x: AxisType.PersonSender, y: AxisType.Insight },
  { x: AxisType.Severity, y: AxisType.ContentLabel },
  { x: AxisType.None, y: AxisType.ContentLabel },
  { x: AxisType.None, y: AxisType.Insight },
  { x: AxisType.None, y: AxisType.Severity },
  { x: AxisType.ExternalReceiver, y: AxisType.EmployeeSender },
  { x: AxisType.EmployeeReceiver, y: AxisType.Insight },
  { x: AxisType.Application, y: AxisType.InfoTypeLabel },
  { x: AxisType.EmployeeReceiverType, y: AxisType.ContentLabel },
  { x: AxisType.EmployeeReceiverType, y: AxisType.InfoTypeLabel },
  { x: AxisType.EmployeeReceiver, y: AxisType.InfoTypeLabel },
  { x: AxisType.EmployeeSenderType, y: AxisType.ContentLabel },
  { x: AxisType.EmployeeSenderType, y: AxisType.InfoTypeLabel },
  { x: AxisType.EmployeeSenderType, y: AxisType.Insight },
  { x: AxisType.EmployeeSender, y: AxisType.InfoTypeLabel },
  { x: AxisType.EmployeeType, y: AxisType.ContentLabel },
  { x: AxisType.EmployeeType, y: AxisType.InfoTypeLabel },
  { x: AxisType.EmployeeType, y: AxisType.Insight },
  { x: AxisType.Employee, y: AxisType.InfoTypeLabel },
  { x: AxisType.ExternalReceiverType, y: AxisType.ContentLabel },
  { x: AxisType.ExternalReceiverType, y: AxisType.InfoTypeLabel },
  { x: AxisType.ExternalReceiverType, y: AxisType.Insight },
  { x: AxisType.ExternalReceiver, y: AxisType.InfoTypeLabel },
  { x: AxisType.FolderType, y: AxisType.InfoTypeLabel },
  { x: AxisType.FolderType, y: AxisType.Insight },
  { x: AxisType.Folder, y: AxisType.InfoTypeLabel },
  { x: AxisType.InfoTypeLabel, y: AxisType.Insight },
  { x: AxisType.NonPrivatePersonReceiverType, y: AxisType.ContentLabel },
  { x: AxisType.NonPrivatePersonReceiverType, y: AxisType.InfoTypeLabel },
  { x: AxisType.NonPrivatePersonReceiver, y: AxisType.InfoTypeLabel },
  { x: AxisType.NonPrivatePersonSenderType, y: AxisType.ContentLabel },
  { x: AxisType.NonPrivatePersonSenderType, y: AxisType.InfoTypeLabel },
  { x: AxisType.NonPrivatePersonSender, y: AxisType.InfoTypeLabel },
  { x: AxisType.OrganizationReceiverType, y: AxisType.ContentLabel },
  { x: AxisType.OrganizationReceiverType, y: AxisType.InfoTypeLabel },
  { x: AxisType.OrganizationReceiverType, y: AxisType.Insight },
  { x: AxisType.OrganizationReceiver, y: AxisType.InfoTypeLabel },
  { x: AxisType.PersonalAddressType, y: AxisType.ContentLabel },
  { x: AxisType.PersonalAddressType, y: AxisType.InfoTypeLabel },
  { x: AxisType.PersonalAddressType, y: AxisType.Insight },
  { x: AxisType.PersonalAddress, y: AxisType.InfoTypeLabel },
  { x: AxisType.PersonReceiverType, y: AxisType.Insight },
  { x: AxisType.PersonSenderType, y: AxisType.Insight },
  { x: AxisType.Severity, y: AxisType.InfoTypeLabel },
  { x: AxisType.None, y: AxisType.InfoTypeLabel },
  { x: AxisType.FolderType, y: AxisType.ContentLabel },
  { x: AxisType.EmployeeReceiverType, y: AxisType.Insight },
  { x: AxisType.EmployeeSender, y: AxisType.EmployeeReceiverType },
  { x: AxisType.EmployeeReceiver, y: AxisType.EmployeeSenderType },
  { x: AxisType.ExternalReceiverType, y: AxisType.EmployeeSender },
  { x: AxisType.OrganizationReceiverType, y: AxisType.EmployeeSender },
  { x: AxisType.PersonalAddressType, y: AxisType.EmployeeSender },
  { x: AxisType.FolderType, y: AxisType.Employee },
  { x: AxisType.ExternalReceiver, y: AxisType.EmployeeSenderType },
  { x: AxisType.ExternalReceiver, y: AxisType.FolderType },
  { x: AxisType.Folder, y: AxisType.EmployeeSenderType },
  { x: AxisType.Folder, y: AxisType.ExternalReceiverType },

  { x: AxisType.Folder, y: AxisType.OrganizationReceiverType },
  { x: AxisType.Folder, y: AxisType.PersonalAddressType },

  { x: AxisType.OrganizationReceiver, y: AxisType.EmployeeSenderType },
  { x: AxisType.OrganizationReceiver, y: AxisType.FolderType },

  { x: AxisType.PersonalAddress, y: AxisType.EmployeeSenderType },
  { x: AxisType.PersonalAddress, y: AxisType.FolderType },

  // untrusted
  { x: AxisType.UntrustedEmployeeReceiver, y: AxisType.ContentLabel },
  { x: AxisType.UntrustedEmployeeReceiver, y: AxisType.Insight },
  { x: AxisType.UntrustedEmployeeReceiverType, y: AxisType.ContentLabel },
  { x: AxisType.UntrustedEmployeeReceiverType, y: AxisType.Insight },

  { x: AxisType.UntrustedOrganization, y: AxisType.ContentLabel },
  { x: AxisType.UntrustedOrganization, y: AxisType.Insight },
  { x: AxisType.UntrustedOrganizationType, y: AxisType.ContentLabel },
  { x: AxisType.UntrustedOrganizationType, y: AxisType.Insight },

  { x: AxisType.UntrustedPersonalAddress, y: AxisType.ContentLabel },
  { x: AxisType.UntrustedPersonalAddress, y: AxisType.Insight },
  { x: AxisType.UntrustedPersonalAddressType, y: AxisType.ContentLabel },
  { x: AxisType.UntrustedPersonalAddressType, y: AxisType.Insight },
];
